// user action types
export const ADD_USER = 'ADD_USER';

// idiary action types
export const ADD_NOTE ='ADD_NOTE';

export const EDIT_NOTE ='EDIT_NOTE';

export const DELETE_NOTE ='DELETE_NOTE';

export const SEARCH_NOTE ='SEARCH_NOTE';

export const GET_NOTES= 'GET_NOTES';

// ireminder action types
export const GET_REMINDER ='GET_REMINDER';

export const EDIT_REMINDER ='EDIT_REMINDER';

export const GET_REMINDERS ='GET_REMINDERS';

export const ADD_REMINDER ='ADD_REMINDER';

export const DELETE_REMINDER ='DELETE_REMINDER';

// ellipsis menu action types
export const TOGGLE_MENU ='TOGGLE_MENU';

